import { mergeClassName as e } from "../../utils/data.js";
import t from "./Calendar.module.js";
import { Anchor as n, Content as r, Portal as i, Root as a } from "../../node_modules/@radix-ui/react-popover/dist/index.js";
import "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region lib/components/DatePicker/DateFieldPopover.tsx
function c({ open: c, onOpenChange: l, trigger: u, children: d, contentProps: f, anchorProps: p, portalProps: m }) {
	return /* @__PURE__ */ s(a, {
		open: c,
		onOpenChange: l,
		children: [/* @__PURE__ */ o(n, {
			...p,
			children: u
		}), /* @__PURE__ */ o(i, {
			...m,
			children: /* @__PURE__ */ o(r, {
				sideOffset: 4,
				...f,
				className: e(t.popoverContent, f?.className),
				children: d
			})
		})]
	});
}
//#endregion
export { c as DateFieldPopover };
